import type { AuthStorePort } from '../ports'
import type { User } from '../domain/models'

interface AuthState {
  token: string | null
  user: User | null
}

export function createAuthStore(): AuthStorePort {
  const authState: AuthState = {
    token: null,
    user: null,
  }

  return {
    get token() {
      return authState.token
    },
    get user() {
      return authState.user
    },
    get isValid() {
      return Boolean(authState.token)
    },
    save(token: string, user: User | null) {
      authState.token = token
      authState.user = user
    },
    clear() {
      authState.token = null
      authState.user = null
    },
  }
}
